const defaultState = {
    carrito: false,
}

function simpleToggler( state = defaultState, { type }){
    switch (type) {
        case 'carrito': {
            return { ...defaultState,
                carrito: !state.carrito}
        }
        default:
            return state;
    }
}

export default simpleToggler;